import React from 'react';
import { bool, func, object } from 'prop-types';

import { connect } from 'react-redux';

import ConfirmActionModal from './ConfirmActionModal';

import { deleteConversion } from '../../actions/architectActions';

const DeleteConversionModal = ({
    companyInfo,
    deleteConversion,
    onClose,
    onDelete,
    open,
    selectedConversion
}) => {
    async function handleDelete() {
        const isDeleted = await deleteConversion(
            selectedConversion.id,
            companyInfo
        );

        if (!isDeleted) {
            return;
        }

        onDelete();
        handleClose();
    }

    function handleClose() {
        onClose();
    }

    return (
        <ConfirmActionModal
            imgSrc="/assets/images/deleteIconColor.svg"
            onClose={handleClose}
            onConfirm={handleDelete}
            open={open}
            title={`Delete Conversion: ${selectedConversion.name}`}
        >
            <p>Warning: You cannot delete a Conversion tied to a Sensor.</p>
            <p>
                Are you sure you want to delete Conversion:{' '}
                {selectedConversion.name}?
            </p>
        </ConfirmActionModal>
    );
};

DeleteConversionModal.defaultProps = {
    deleteConversion:   () => { },
    onClose:            () => { },
    onDelete:           () => { },
    open:               false,
    selectedConversion: {}
};

DeleteConversionModal.propTypes = {
    deleteConversion:   func,
    onClose:            func,
    onDelete:           func,
    open:               bool.isRequired,
    selectedConversion: object
};

const mapStateToProps = state => {
    return {
        companyInfo:        state.companyInfo,
        selectedConversion: state.architect.selectedConversion
    };
};

const mapDispatchToProps = {
    deleteConversion
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeleteConversionModal);
